import { render, staticRenderFns } from "./OneProductRelations.vue?vue&type=template&id=e29b4280&scoped=true&"
import script from "./OneProductRelations.vue?vue&type=script&lang=ts&"
export * from "./OneProductRelations.vue?vue&type=script&lang=ts&"
import style0 from "./OneProductRelations.vue?vue&type=style&index=0&id=e29b4280&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29b4280",
  null
  
)

export default component.exports